import Microgame from '../engine/Microgame.js';

export default class HighFiveGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Tope-là !`, en: `High Five!`, es: `¡Choca esos cinco!` },
            controls: { fr: `Appuie quand les deux mains se croisent`, en: `Tap when the two hands cross`, es: `Toca cuando las dos manos se crucen` },
            objective: { fr: `Fais un tope-là parfait avec un bon timing`, en: `Give a perfect high-five with good timing`, es: `Choca esos cinco perfectamente a tiempo` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2"><path d="M18 11V6a2 2 0 0 0-4 0v4"/><path d="M14 10V4a2 2 0 0 0-4 0v6"/><path d="M10 10.5V5a2 2 0 0 0-4 0v9"/><path d="M6 14v-2a2 2 0 0 0-4 0v4.5A7.5 7.5 0 0 0 9.5 24h1a7.5 7.5 0 0 0 7.5-7.5V14"/></svg>`,
            actions: [
                { type: 'wait', duration: 460 },
                { type: 'tap', x: 50, y: 50, duration: 140 },
                { type: 'wait', duration: 340 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.hand1 = null;
        this.hand2 = null;
        const speedMult = engine.speedMultiplier || 1.0;
        this.speed = 300 * (1 + (speedMult - 1) * 0.35);
        this.distance = 150; // Distance from center
    }

    setup() {
        this.engine.ui.instruction.textContent = "SYNC!";

        // Center marker
        const center = document.createElement('div');
        center.style.position = 'absolute';
        center.style.width = '4px';
        center.style.height = '40px';
        center.style.background = 'rgba(255, 255, 255, 0.2)';
        center.style.top = '50%';
        center.style.left = '50%';
        center.style.transform = 'translate(-50%, -50%)';
        this.container.appendChild(center);

        // Hand 1 (Left) - Primary
        this.hand1 = document.createElement('div');
        this.hand1.style.position = 'absolute';
        this.hand1.style.width = '60px';
        this.hand1.style.height = '60px';
        this.hand1.style.background = this.primaryColor;
        this.hand1.style.borderRadius = '10px';
        this.hand1.style.top = '50%';
        this.hand1.style.left = `calc(50% - ${this.distance}px)`;
        this.hand1.style.transform = 'translate(-50%, -50%)';
        this.hand1.style.boxShadow = `0 0 15px ${this.primaryColor}`;
        this.container.appendChild(this.hand1);

        // Hand 2 (Right) - Secondary
        this.hand2 = document.createElement('div');
        this.hand2.style.position = 'absolute';
        this.hand2.style.width = '60px';
        this.hand2.style.height = '60px';
        this.hand2.style.background = this.secondaryColor;
        this.hand2.style.borderRadius = '10px';
        this.hand2.style.top = '50%';
        this.hand2.style.left = `calc(50% + ${this.distance}px)`;
        this.hand2.style.transform = 'translate(-50%, -50%)';
        this.hand2.style.boxShadow = `0 0 15px ${this.secondaryColor}`;
        this.container.appendChild(this.hand2);

        this.onDown = this.onDown.bind(this);
        this.engine.input.element.addEventListener('pointerdown', this.onDown);
    }

    update(dt) {
        if (!this.active || this.won) return;

        this.distance -= this.speed * (dt / 1000);

        this.hand1.style.left = `calc(50% - ${this.distance}px)`;
        this.hand2.style.left = `calc(50% + ${this.distance}px)`;

        // If they cross and miss
        if (this.distance < -40) {
            this.lose();
        }
    }

    onDown() {
        if (!this.active || this.won) return;

        // Check overlap
        // Distance is from center to center of hand?
        // Hands are 60px wide. Center is at 0.
        // If distance is close to 0 (e.g. < 30), they touch.

        if (Math.abs(this.distance) < 30) {
            this.win();
            // Visual effect - No white flash, just glow
            this.hand1.style.background = '#fff';
            this.hand2.style.background = '#fff';
            this.hand1.style.boxShadow = `0 0 30px #fff`;
            this.hand2.style.boxShadow = `0 0 30px #fff`;
        } else {
            // Missed
            this.lose();
        }
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onDown);
    }
}
